import { formValueSelector } from 'redux-form';
import { travelerInputs } from '@eti/utils';
const {
  TAX_ID_INPUT
} = travelerInputs;
export const getSessionTaxId = () => sessionStorage.getItem(TAX_ID_INPUT) || '';
export const persistTaxId = taxId => {
  sessionStorage.setItem(TAX_ID_INPUT, taxId);
};
export const getTaxId = (name, form) => state => {
  const formData = formValueSelector(form)(state, name);
  return formData;
};
//# sourceMappingURL=utils.js.map